import { parseToken } from 'du/utils'

function addSign(obj) {
  return parseToken(obj, '048a9c4943398714b356a696503d2d36', true)
}

export { addSign }
